module.exports = __webpack_public_path__ + "static/email-template-account-activation-doggify-1186da1e30d96eef4663afa0680ddeb5.jpg";